import {
  ApolloClient,
  InMemoryCache,
} from "@apollo/client";

const CreateClient = () => {
  const uri = `${process.env.REACT_APP_SERVER_URL}${process.env.REACT_APP_GRAPHQL_ENDPOINT}`;
  return new ApolloClient({
    uri: uri,
    cache: new InMemoryCache(),
  });
};

export default CreateClient;
